import React from 'react';
import { FadeIn } from './ui';
import { Brain } from 'lucide-react';
export const Mechanism = () => {
  return <section className="py-16 px-6" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <FadeIn data-id="element-86">
          <div className="bg-surface border border-white/5 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-87">
            {/* Subtle background glow */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-amber/5 blur-[80px] rounded-full pointer-events-none" data-id="element-88"></div>

            <div className="flex items-center gap-4 mb-8" data-id="element-89">
              <div className="p-3 bg-midnight rounded-full border border-white/5" data-id="element-90">
                <Brain className="text-amber" size={24} strokeWidth={1.5} data-id="element-91" />
              </div>
              <h2 className="text-2xl md:text-3xl m-0" data-id="element-92">The Unique Mechanism</h2>
            </div>

            <h3 className="text-xl md:text-2xl font-serif italic text-amber mb-6" data-id="element-93">
              Introducing: The Cognitive Shuffler.
            </h3>

            <div className="space-y-6 text-parchment-muted font-light leading-loose text-lg relative z-10" data-id="element-94">
              <p data-id="element-95">
                This isn't a "relaxation" technique—it’s a manual gear-shift for
                your gray matter. By using a specific sequence of
                non-associative imagery, we force the brain to mimic
                "micro-dreams."
              </p>
              <p data-id="element-96">
                This tricks your analytical centers into thinking you've already
                entered the sleep transition.
              </p>
              <p className="text-parchment font-medium text-xl border-l-2 border-amber/30 pl-6 py-2 my-8" data-id="element-97">
                You cannot worry in words and visualize random objects at the
                same time.
              </p>
              <p data-id="element-98">
                The visual brain always wins, effectively "scrambling" the
                anxiety loop so sleep can take over.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};